import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"
import { FACTOR_SENSITIVITY_LOOKBACK_DAYS } from "helpers/factorSensitivity"
import { Link } from "@mui/material"

import "./style.scss"

export default function NotEnoughHistoricalFactorSensitivityData({ assetTypeName, isOpPro, startDate, handleSelectPredicted, displayChangeDateMsg = true }) {
  return <div className="components_not-enough-historical-factor-sensitivity-data">
    <h2>Historical factor sensitivity not available for this {assetTypeName} with limited dates</h2>
    <p>
      You don&apos;t have access to enough historical factor or
      &nbsp;
      {assetTypeName}
      &nbsp;
      data to be able to calculate historical factor sensitivity from
      &nbsp;
      {startDate}
      &nbsp;
      using
      &nbsp;
      {FACTOR_SENSITIVITY_LOOKBACK_DAYS}
      &nbsp;
      day lookback.
      {displayChangeDateMsg && <> Try changing it to a date at least {FACTOR_SENSITIVITY_LOOKBACK_DAYS} trading days after the first {assetTypeName} holdings date.</>}
    </p>
    {!isOpPro && <p><Link onClick={handleSelectPredicted} underline="hover">Predicted factor sensitivity</Link> information is available for this {assetTypeName}.</p>}
  </div>
}

NotEnoughHistoricalFactorSensitivityData.propTypes = {
  assetTypeName: PropTypes.string.isRequired,
  isOpPro: PropTypes.bool.isRequired,
  startDate: DATE.isRequired,
  handleSelectPredicted: PropTypes.func.isRequired,
  displayChangeDateMsg: PropTypes.bool.isRequired,
}
